export default __webpack_public_path__ + "static/8_35-d42ebd9c4471165c3278705d672964cd.png";